import React, { useEffect, useState } from 'react';
import { ButtonUI, DeleteDialogUI, DialogUI, FormButtonPanelUI } from '../../../Interface';
import { Form, Formik } from 'formik';
import { Box } from '@mui/material';
import Yup from '../../../../utils/yup';
import calendarEventService from '../../../../service/calendarEvent.service';
import addNotification from '../../../../utils/addNotification';
import { NotificationType } from '../../../../config';
import dayjs from 'dayjs';
import CalendarEventFields from './CalendarEventFields';

const CalendarEventDialog = ({ open, handleClose, user, data, setRefetch }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [initValues, setInitValues] = useState({});
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const defaultValues = {
    title: '',
    startDate: dayjs(),
    endDate: dayjs().add(1, 'hour'),
  };

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setInitValues(data);
      setIsEditing(true);
    } else {
      setInitValues(defaultValues);
      setIsEditing(false);
    }
  }, [data]);

  const validationSchema = Yup.object().shape({
    title: Yup.string().required(),
    startDate: Yup.string().required(),
    endDate: Yup.string().required(),
  });

  const handleSubmit = (values) => {
    if (isEditing) {
      updateObject(values);
    } else {
      handleInsertObject(values);
    }
  };

  const updateObject = async (values) => {
    const updData = {
      ...values,
      updatedBy: user.userId,
      startDate: dayjs(values.startDate).toISOString(),
      endDate: dayjs(values.endDate).toISOString(),
    };

    calendarEventService.updateData(updData).then((data) => {
      addNotification({
        content: 'Sikeres módosítás!',
        type: NotificationType.SUCCESS,
      });

      setIsEditing(false);
      handleClose();
      setRefetch(true);
    });
  };

  const handleInsertObject = async (values) => {
    const insertObject = {
      ...values,
      createdBy: user.userId,
      startDate: dayjs(values.startDate).toISOString(),
      endDate: dayjs(values.endDate).toISOString(),
    };

    calendarEventService
      .createData(insertObject)
      .then((data) => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.SUCCESS,
        });

        handleClose();
        setRefetch(true);
      })
      .finally(() => {
        //@TODO loader
      });
  };

  const handleRemoveElement = () => {
    calendarEventService.deleteData(data.id).then(() => {
      setShowDeleteDialog(false);
      handleClose();
      setRefetch(true);
    });
  };

  return (
    <>
      <DialogUI
        open={open}
        onClose={handleClose}
        headerContent="Naptári események"
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '100%',
              maxWidth: '600px',
            },
          },
        }}
      >
        <Formik
          initialValues={initValues}
          validationSchema={validationSchema}
          validateOnChange={false}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({}) => (
            <Form>
              <CalendarEventFields />
              <Box display="flex" justifyContent="center" gap={3} alignItems="center">
                <Box>
                  <FormButtonPanelUI
                    onCancelClick={() => {
                      setIsEditing(false);
                      handleClose();
                    }}
                  />
                </Box>
                <Box>
                  <ButtonUI
                    className="bg-danger"
                    text="Törlés"
                    onClick={() => setShowDeleteDialog(true)}
                    disabled={!isEditing}
                  />
                </Box>
              </Box>
            </Form>
          )}
        </Formik>
      </DialogUI>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
      />
    </>
  );
};

export default CalendarEventDialog;
